import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useLocation, useHistory } from "react-router";
import { inject, observer } from "mobx-react";
import { COMMON_UTIL } from "@/common/util/common.util";
import { isAgreePush } from "../../nativebridge/JsToNative";
import { NativeToJsBridge, NativeToJsEventName } from "../../nativebridge/NativeToJs";
import { Root } from "@/common/Styled/CommonStyled";

/* components */
import BottomNavigation from "@/views/CommonComponent/BottomNavigation";
import Header from "./Header";
import PushPopup from "./EventPopup/PushPopup";
import CommonDialog from "@/views/CommonComponent/CommonDialog";
import { useToast } from "../../components/useToast";
import { isHome } from "@/nativebridge/JsToNative";
import dayjs from "dayjs";

// 컴포넌트들
import TabContainer from "./components/TabContainer";

const PendingProfileApplyToastKey = "_PENDING_PROFILE_APPLY_TOAST_";
const PendingDeviceDisconnectToastKey = "_PENDING_DEVICE_DISCONNECT_TOAST_";

function Home(props) {
  const history = useHistory();
  const [tabValue, setTabValue] = useState("board");
  const {
    intl,
    authStore,
    userStore,
    homeStore,
    loadingStore,
    pronunciationStore,
    reportStore,
    languageStore,
    modalStore,
  } = props;
  const location = useLocation();
  const { showDeleteToast } = useToast();
  const [deviceSelectorOpen, setDeviceSelectorOpen] = useState(false);





  const handleChangeDevice = () => {
    userStore.setSelectedDevice(userStore.newSelectedDevice);
    modalStore.setChangePokoroModalOpen(false);
    homeStore.setSelectedCalendarDate(new Date());
    homeStore.getCalendar(authStore.loginUser.id, userStore.selectedDevice.deviceId, (userId, deviceId) => homeStore.getHomeData(userId, deviceId));

    pronunciationStore.setDate(dayjs(homeStore.selectedCalendarDate));
    reportStore.setDate(dayjs(homeStore.selectedCalendarDate));

    homeStore.setIsChangeCalendar(false);
    setDeviceSelectorOpen(false);
  }

  const handleCancelChangeDevice = () => {
    userStore.setNewSelectedDevice('');
    modalStore.setChangePokoroModalOpen(false);
  }


  //항상 페이지 상단
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    loadingStore.setIsLoading(userStore.getIsLoading || homeStore.getIsLoading);
  }, [userStore.getIsLoading, homeStore.getIsLoading, loadingStore]);

  useEffect(() => {
    /* userStore.getUserDeviceList(authStore.loginUser.id, userStore.selectedDevice === "", (userId, deviceId) =>
        homeStore.getCalendar(userId, deviceId, (userId, deviceId) =>
            homeStore.getHomeData(userId, deviceId)
        )
    ); */
    userStore.getUserDeviceList(authStore.loginUser.id, userStore.selectedDevice === "", (userId, deviceId) => {
      // 캘린더 데이터와 현재 날짜의 홈 데이터를 함께 로드
      homeStore.getCalendar(userId, deviceId, (userId, deviceId) => {
        // 현재 선택된 날짜의 홈 데이터도 함께 로드
        homeStore.getHomeData(userId, deviceId);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  useEffect(() => {
    isHome(true);
    return () => {
      isHome(false);
    };
  }, []);

  // 컴포넌트 마운트 시 팝업 표시
  useEffect(() => {
    if (!homeStore.isPushPopupChecked) {
      userStore.getUserPushAgreement(authStore.loginUser.id, () => {
        homeStore.setIsPushPopupChecked(true);
        if (userStore.userPushAgreement === '') {
          homeStore.setIsPushPopupOpen(true);
        } else {
          if (COMMON_UTIL.isWebView()) {
            isAgreePush(userStore.userPushAgreement.agreed ? 1 : 0);
          }
        }
      });
    }
  }, []);

  useEffect(() => {
    NativeToJsBridge.instance.addEventListener(
        NativeToJsEventName.onSetPushAgree,
        async (event) => {
          const isAgree = event.isAgree;
          console.log("========NativeToJs=========== isAgree=" + isAgree);
          userStore.updateUserPushAgreement(authStore.loginUser.id, isAgree, () => {
            if (!isAgree) {
              const now = new Date();
              const formattedDate = `${now.getFullYear()}. ${String(now.getMonth() + 1).padStart(2, '0')}. ${String(now.getDate()).padStart(2, '0')}`;
              showDeleteToast(
                  <span style={{ whiteSpace: "pre-line" }}>
                    {intl.formatMessage({ id: "Toast_marketing_notification_off" })} {/* 푸시 알림을 거부했습니다. */}
                    &nbsp;{formattedDate}
                  </span>
              );
            }
          });
        }
    );

    return () => {
      NativeToJsBridge.instance.removeEventListener(
          NativeToJsEventName.onSetPushAgree
      );
    };
  }, []);

  useEffect(() => {
    const shouldShowProfileApplyToast =
        localStorage.getItem(PendingProfileApplyToastKey) !== null;
    if (!shouldShowProfileApplyToast) {
      return;
    }
    showDeleteToast(localStorage.getItem(PendingProfileApplyToastKey));
    localStorage.removeItem(PendingProfileApplyToastKey);
  }, [intl, showDeleteToast]);

  useEffect(() => {
    const shouldShow = localStorage.getItem(PendingDeviceDisconnectToastKey) === "true";
    if (!shouldShow) {
      return;
    }
    localStorage.removeItem(PendingDeviceDisconnectToastKey);
    showDeleteToast(intl.formatMessage({ id: "device_disconnect_success_toast" }));
  }, [intl, showDeleteToast]);


  const handleEventPopupClose = () => {
    homeStore.setIsPushPopupOpen(false);
  };

  const getUnder14Date = () => {
    const today = new Date();
    const year = today.getFullYear() - 14;
    const month = today.getMonth() + 1; // 1~12월
    const day = today.getDate();

    return {
      year: year,
      month: month,
      day: day
    }
  };

  return (
    <Root>
      <PushPopup
        isOpen={homeStore.isPushPopupOpen}
        onClose={handleEventPopupClose}
      />
      {/* 탭별 컨텐츠 */}
      <TabContainer tabValue={tabValue} deviceSelectorOpen={deviceSelectorOpen} setDeviceSelectorOpen={setDeviceSelectorOpen} />

      <BottomNavigation
        value={tabValue}
        handleChangeTab={(event, newValue) => setTabValue(newValue)}
      />

      <CommonDialog
        open={modalStore.changePokoroModalOpen}
        title={intl.formatMessage({ id: "change_device_title" })}
        subText={
          <span> {intl.formatMessage({ id: "change_device_info" })}</span>
        }
        onClick1={handleCancelChangeDevice}
        onClick2={handleChangeDevice}
        LeftButtonText={intl.formatMessage({ id: "dialog_NoButton" })}
        RightButtonText={intl.formatMessage({ id: "dialog_YesButton" })}
      />


    </Root>
  );
}

export default injectIntl(
  inject(
    "authStore",
    "userStore",
    "homeStore",
    "loadingStore",
    "pronunciationStore",
    "reportStore",
    "languageStore",
    "modalStore"
  )(observer(Home))
);
